// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"19b3085d","362":"9698430a","397":"39043e18","449":"2b96e195","511":"f95c6372","635":"be4f0383","706":"02da71b7","876":"733f8467"}[chunkId] + ".chunk.js";
};